// extracted by extract-css-chunks-webpack-plugin
module.exports = {"limit-count":"_1LA_wB","limit-count-warning":"_1hkV1j"};